import React, { useContext, useState } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"
import NavbarWrapper from "../base/Navbar"
import Drawer from "../base/Drawer"
import Button from "../base/Button"
import Logo from "../base/UI/Logo"
import Box from "../base/Box"
import HamburgMenu from "../HamburgMenu"
import Container from "../UI/Container"
import { DrawerContext } from "../../contexts/DrawerContext"
import ScrollSpyMenu from "../ScrollSpyMenu"

import LogoImage from "../../assets/images/logo-white.png"
import LogoImageAlt from "../../assets/images/logo.png"
import { useWindowSize } from "../../hooks/useWindowSize"

const Navbar = ({ navbarStyle, logoStyle, button, row, menuWrapper }) => {
  const { state, dispatch } = useContext(DrawerContext)

  // Toggle drawer
  const toggleHandler = () => {
    dispatch({
      type: "TOGGLE",
    })
  }

  const Data = useStaticQuery(graphql`
    query {
      dataJson {
        MENU_ITEMS {
          label
          path
          offset
        }
      }
    }
  `)
  const [key, setRefreshComp] = useState(1)
  useWindowSize({
    resize: () => {
      setRefreshComp(Math.random(1000000000))
    },
  })

  return (
    <NavbarWrapper {...navbarStyle} className="saas_navbar" key={key}>
      <Container>
        <Box {...row}>
          <Logo
            href="/"
            logoSrc={LogoImage}
            title="Portfolio"
            logoStyle={logoStyle}
            className="main-logo"
          />
          <Logo
            href="/"
            logoSrc={LogoImageAlt}
            title="Portfolio"
            logoStyle={logoStyle}
            className="logo-alt"
          />
          <Box {...menuWrapper}>
            <ScrollSpyMenu
              className="main_menu"
              menuItems={Data.dataJson.MENU_ITEMS}
              offset={-70}
            />

            <Link className="navbar_button" to="/">
              <Button {...button} title="CONTACT US" />
            </Link>
            <Drawer
              width="420px"
              placement="right"
              drawerHandler={<HamburgMenu barColor="#fff" />}
              open={state.isOpen}
              toggleHandler={toggleHandler}
            >
              <ScrollSpyMenu
                className="mobile_menu"
                menuItems={Data.dataJson.MENU_ITEMS}
                drawerClose={true}
                offset={-100}
              />

              <Link className="navbar_drawer_button" to="/">
                <Button {...button} title="CONTACT US" />
              </Link>
            </Drawer>
          </Box>
        </Box>
      </Container>
    </NavbarWrapper>
  )
}

Navbar.propTypes = {
  navbarStyle: PropTypes.object,
  logoStyle: PropTypes.object,
  button: PropTypes.object,
  row: PropTypes.object,
  menuWrapper: PropTypes.object,
}

Navbar.defaultProps = {
  navbarStyle: {
    minHeight: "70px",
    display: "block",
  },
  row: {
    flexBox: true,
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  logoStyle: {
    maxWidth: ["120px", "130px"],
  },
  button: {
    type: "button",
    fontSize: "13px",
    fontWeight: "700",
    borderRadius: "4px",
    pl: "15px",
    pr: "15px",
    colors: "secondaryWithBg",
    minHeight: "auto",
    height: "40px",
  },
  menuWrapper: {
    flexBox: true,
    alignItems: "center",
  },
}

export default Navbar
